
import PresentionChart from "../../../assets/duotone/PresentionChart.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PresentionChartIcon({ className, dataTestid = "PresentionChartIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <PresentionChart data-testid={dataTestid} className={classes} {...rest} />
  );
}
